export var EntitlementActionKind;
(function (EntitlementActionKind) {
    EntitlementActionKind["ModifyEntitlement"] = "ModifyEntitlement";
})(EntitlementActionKind || (EntitlementActionKind = {}));
